module.exports = __webpack_public_path__ + "img/019.f95c0ddc.png";